import React from 'react';
import classNames from 'classnames';
import css from './SdkVideo.css';

const SdkVideo = ({
    entity,
    draggable = false,
    autoPlay = true,
    controls = true,
    loop = true,
    muted = true,
    rootClassName = '',
    onLoadedData = () => null,
    playsInline = true,
    ...rest
}) =>
    Object.values(entity.attributes.variants).reduce((src, { url }) => {
        if (src) return src;

        if (url) {
            return (
                <video
                    {...rest}
                    className={classNames(css.root, {
                        [rootClassName]: !!rootClassName,
                    })}
                    onLoadedData={onLoadedData}
                    controls={controls}
                    draggable={draggable}
                    autoPlay={autoPlay}
                    loop={loop}
                    muted={muted}
                    playsInline={playsInline}
                >
                    <source src={url} type="video/mp4" />
                    <source src={url} type="video/ogg" />
                    <source src={url} type="video/webm" />
                    <source src={url} type="video/quicktime" />
                    Your browser doesn't support HTML5 video tag.
                </video>
            );
        }

        return null;
    }, null);

export default SdkVideo;
